import { PromptModel as PromptModelResponse } from '~/api/sylvanus/typedefs.autogen';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  modelId: Uuid;
  workflowId: Uuid;
}

type Response = PromptModelResponse;

export const getPromptModelWorkflowPrediction = async ({
  modelId,
  workflowId,
}: Request): Promise<Response> => {
  const response = await sylvanus.get(
    `/model/${modelId}/predict/${workflowId}`,
  );

  return response;
};
